export const GATES = [
    { id: 'discovery', title: 'Discovery Session', summary: 'Answers noted, treatments confirmed' },
    { id: 'plan', title: 'Plan', summary: 'Agreement signed, plan approved' },
    { id: 'prepare', title: 'Prepare', summary: 'Test load reviewed, freeze date set' },
    { id: 'launch', title: 'Launch', summary: 'Final load, go-live' },
    { id: 'succeed', title: 'Succeed', summary: 'Firm signs off' },
];
export const GATE_IDS = GATES.map((g) => g.id);
export const gateTitle = (id) => GATES.find((g) => g.id === id).title;
/** The gate after `id`, null after the last. */
export const nextGate = (id) => GATE_IDS[GATE_IDS.indexOf(id) + 1] ?? null;
export const STANDARD_TASKS = [
    { id: 'discovery.review', gate: 'discovery', title: 'Review the submission', kind: 'manual', owner: 'lead' },
    { id: 'discovery.session', gate: 'discovery', title: 'Hold the Discovery Session', kind: 'manual', owner: 'lead' },
    { id: 'discovery.treatments', gate: 'discovery', title: 'Confirm every treatment', kind: 'auto', owner: 'lead' },
    { id: 'discovery.notes', gate: 'discovery', title: 'Note the answers on every section', kind: 'auto', owner: 'lead' },
    { id: 'plan.send_agreement', gate: 'plan', title: 'Send the agreement', kind: 'auto', owner: 'lead' },
    { id: 'plan.draft_plan', gate: 'plan', title: 'Draft the migration plan', kind: 'auto', owner: 'lead' },
    { id: 'plan.firm_signs', gate: 'plan', title: 'Firm signs the agreement', kind: 'auto', owner: 'firm' },
    { id: 'plan.firm_approves', gate: 'plan', title: 'Firm approves the plan', kind: 'auto', owner: 'firm' },
    { id: 'prepare.remaining_files', gate: 'prepare', title: 'Collect the remaining migration files', kind: 'step', owner: 'lead', stepId: 'prepare.remaining_files' },
    { id: 'prepare.test_load', gate: 'prepare', title: 'Test-load the data into a private copy', kind: 'step', owner: 'lead', stepId: 'prepare.test_load' },
    { id: 'prepare.firm_reviews', gate: 'prepare', title: 'Firm reviews the test-load results', kind: 'step', owner: 'firm', stepId: 'prepare.firm_reviews' },
    { id: 'prepare.freeze_date', gate: 'prepare', title: 'Agree the freeze date and launch day', kind: 'step', owner: 'lead', stepId: 'prepare.freeze_date_agreed' },
    { id: 'launch.walkthrough', gate: 'launch', title: 'Guided walkthrough for the firm’s team', kind: 'step', owner: 'lead', stepId: 'launch.walkthrough' },
    { id: 'launch.freeze_exports', gate: 'launch', title: 'Fresh exports on the freeze date', kind: 'step', owner: 'firm', stepId: 'launch.freeze_exports' },
    { id: 'launch.final_load', gate: 'launch', title: 'Final load and checks', kind: 'step', owner: 'lead', stepId: 'launch.final_load' },
    { id: 'launch.go_live', gate: 'launch', title: 'Go-live', kind: 'step', owner: 'lead', stepId: 'launch.go_live' },
    { id: 'succeed.support', gate: 'succeed', title: 'Hands-on support through the first weeks', kind: 'step', owner: 'lead', stepId: 'succeed.support' },
    { id: 'succeed.check_ins', gate: 'succeed', title: 'Check-ins', kind: 'step', owner: 'lead', stepId: 'succeed.check_ins' },
    { id: 'succeed.sign_off', gate: 'succeed', title: 'Firm confirms everything works', kind: 'step', owner: 'firm', stepId: 'succeed.sign_off' },
];
export const standardTask = (id) => (id ? STANDARD_TASKS.find((t) => t.id === id) ?? null : null);
/** The state of an auto or step task. A manual task's state is its own tick. */
export function derivedState(t, f) {
    if (t.kind === 'step') {
        const s = f.steps.find((x) => x.id === t.stepId);
        return { done: s?.state === 'done', at: s?.state === 'done' ? s.at : null, detail: null };
    }
    const when = (at) => ({ done: at !== null, at, detail: null });
    switch (t.id) {
        case 'discovery.treatments': {
            const { total, confirmed } = f.treatments;
            return { done: confirmed >= total, at: null, detail: total ? `${confirmed} of ${total} confirmed` : 'Nothing to confirm' };
        }
        case 'discovery.notes':
            return { done: f.missingNotes.length === 0, at: null, detail: f.missingNotes.length ? `No note on ${f.missingNotes.join(', ')}` : 'Every section has a note' };
        case 'plan.send_agreement': return when(f.agreementSentAt);
        case 'plan.draft_plan': return when(f.planDraftedAt);
        case 'plan.firm_signs': return when(f.agreementSignedAt);
        case 'plan.firm_approves': return when(f.planApprovedAt);
        default: return { done: false, at: null, detail: null };
    }
}
/** What still stops a gate from closing, in words for the close button. Empty when it can close. */
export function closeBlockers(tasksLeft, lessons) {
    const out = [];
    if (tasksLeft)
        out.push(`${tasksLeft} ${tasksLeft === 1 ? 'task' : 'tasks'} left`);
    if (!lessons?.trim())
        out.push('write the lessons learned');
    return out;
}
/** Longest task title and lessons learned, in characters. */
export const TASK_TITLE_MAX = 300;
export const LESSONS_MAX = 10_000;
/** Hours staff can log when closing a gate (added to onboarding hours on the KPI page). */
export const GATE_HOURS_MAX = 200;
//# sourceMappingURL=gates.js.map